export default __webpack_public_path__ + "static/media/Oops.6cd1a0db.svg";